// 表示最大期間 720日 (約2年)
export const MAX_DISPLAY_SPAN_DAYS = 720;
